import { StoryblokBulletList } from './StoryblokBulletList'

export default StoryblokBulletList
